import { useState } from "react";

import { Classes, Icon } from "@blueprintjs/core";
import styled from "@emotion/styled";

import { RichContentRenderer } from "@/components/helpers/ui/RichContentRenderer";
import { Box, Flex } from "@/components/layout/flexbox";
import { EvaluationFeedbackExamples } from "@/components/pages_logged_in/roleplays/details/scenario/session/EvaluationFeedbackExamples";
import { FadeInBox } from "@/components/pieces/FadeInBox";
import { Clickable } from "@/components/pieces/interaction/Clickable";
import { GradeIcon } from "@/components/pieces/roleplays/GradeIcon";
import { MIDTEXT_COLOR, SUBTEXT_COLOR } from "@/css/constants";
import { Evaluation } from "@/types/evaluation";
import { ensureNonNullArray } from "@/utils/array";

const FeedbackDisplay = styled(Box)`
  p:not(:first-child):has(> strong:only-child) {
    margin-top: 16px;
  }
  p:has(> strong:only-child) {
    margin-bottom: 4px;
  }
  strong {
    font-weight: 600;
    color: ${MIDTEXT_COLOR};
  }
  blockquote {
    font-size: 16px;
    padding: 4px 18px;
    margin-bottom: 11px;
  }
`;

export function FeedbackContent({ evaluation }: { evaluation: Evaluation }) {
  const { feedback, summary } = evaluation;
  const summaryObjects = summary ? JSON.parse(summary) : {};
  const feedbackExamples = ensureNonNullArray(evaluation.feedbackExamples);

  console.log(summaryObjects);

  if (summary) {
    return (
      <FadeInBox css={{ overflow: "hidden" }} width={"100%"}>
        <Box fontSize={14} fontWeight={600} mb={1} color={MIDTEXT_COLOR}>
          Summary
        </Box>
        <Box fontWeight={400} fontSize={16}>
          {summaryObjects.overallAssessment}
        </Box>
        {summaryObjects?.tipsForImprovement?.length > 0 && (
          <Box mt={20}>
            <Box fontSize={14} fontWeight={600} color={MIDTEXT_COLOR}>
              Tips for Improvement
            </Box>
            <RichContentRenderer content={summaryObjects.tipsForImprovement} />
          </Box>
        )}
        {feedbackExamples.length > 0 && (
          <Box pt={20}>
            <EvaluationFeedbackExamples feedbackExamples={feedbackExamples} />
          </Box>
        )}
      </FadeInBox>
    );
  }

  return (
    <FeedbackDisplay>
      <RichContentRenderer content={feedback} />
    </FeedbackDisplay>
  );
}

export function CollapsibleFeedback({
  evaluation,
}: {
  evaluation: Evaluation;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box className="bas round-corners" backgroundColor="#FFF" mt={3}>
      <Clickable onClick={() => setIsOpen((prev) => !prev)}>
        <Flex p={3} justifyContent="space-between" alignItems="center">
          <Flex alignItems="center">
            <GradeIcon grade={evaluation.grade ?? undefined} />
            <Box ml={3}>{evaluation.evaluationCriterionItem?.name}</Box>
          </Flex>
          <Icon
            icon={isOpen ? "chevron-up" : "chevron-down"}
            color={SUBTEXT_COLOR}
          />
        </Flex>
      </Clickable>
      {isOpen && (
        <Box p={24} className={`bts ${Classes.RUNNING_TEXT}`}>
          <FeedbackContent evaluation={evaluation} />
        </Box>
      )}
    </Box>
  );
}
